(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-bogo-storefront"] && !Shopify.designMode) return;
  try {
    
(function(){function syncButtons(){document.querySelectorAll('[data-dt-email-category]').forEach(function(section){var count=Number(section.getAttribute('data-count')||0);var limit=window.innerWidth<=749?2:4;var btn=section.querySelector('[data-dt-category-toggle]');if(btn)btn.hidden=count<=limit;});}document.addEventListener('click',function(e){var btn=e.target.closest&&e.target.closest('[data-dt-category-toggle]');if(!btn)return;var category=btn.closest('[data-dt-email-category]');var expanded=category.classList.toggle('is-expanded');btn.setAttribute('aria-expanded',expanded?'true':'false');btn.textContent=expanded?btn.dataset.showLess||'Show less':btn.dataset.viewAll||'View all';});syncButtons();window.addEventListener('resize',syncButtons,{passive:true});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
